@if (facetList$ | async; as facetList) {
    @if (isMyAssortmentSelectedOrActiveFacets() | async) {
        <div
            class="active-facets-wrapper fade-white"
        >
            <div class="active-facets">
                @if (myAssortmentLabelSuffix$ | async; as myAssortmentLabelSuffix) {
                    @if (isMyAssortmentSelected() | async) {
                        <button
                            (click)="removeMyAssortment()"
                            class="btn-facet btn-sm d-inline">
                            <span
                                [innerHTML]="('aimo.user.myAssortment'+myAssortmentLabelSuffix.suffix)| cxTranslate"></span>
                            <i class="aimo-icon icon-inline icon-x icon-sm ml-2"></i>
                        </button>
                    }
                }
                @if (activeFacetList$ | async; as activeFacets) {
                    @for (facet of activeFacets; track facet.facetValueName) {
                        <button
                            class="btn-facet btn-sm d-inline"
                            (click)="clickFacet(getLinkParams(facet))"
                            [cxFocus]="{ key: getFocusKey(facetList, facet) }"
                            (keydown.space)="removeFilterWithSpacebar($event)"
                            [attr.aria-label]="'productList.activeFilter' | cxTranslate: { filter: facet.facetValueName }">
                            <span [innerHTML]="facet.facetValueName"></span>
                            <i class="aimo-icon icon-inline icon-x icon-sm ml-2"></i>
                        </button>
                    }
                    @if (activeFacets?.length > 0) {
                        <button
                            class="btn-facet btn-sm d-inline clear-all-facets"
                            (click)="clickFacet(clearUrlParams)"
                            (keydown.space)="removeFilterWithSpacebar($event)"
                            [attr.aria-label]="'productList.faceets.empty' | cxTranslate">
                            <span>{{ 'productList.faceets.empty' | cxTranslate }}</span>
                            <i class="aimo-icon icon-inline icon-x icon-sm ml-2"></i>
                        </button>
                    }
                }
            </div>
        </div>
    }
}
